"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SapphireMapperLinearFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SapphireMapperLinearFactory = /** @class */ (function (_super) {
    __extends(SapphireMapperLinearFactory, _super);
    function SapphireMapperLinearFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SapphireMapperLinearFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SapphireMapperLinearFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SapphireMapperLinearFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SapphireMapperLinearFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SapphireMapperLinearFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SapphireMapperLinearFactory;
}(contracts_1.ContractFactory));
exports.SapphireMapperLinearFactory = SapphireMapperLinearFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_score",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_scoreMax",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_lowerBound",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_upperBound",
                type: "uint256",
            },
        ],
        name: "map",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
